import { useMemo, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { useComponentDidMount } from '../../hooks';
import { SelectInput } from '../forms';
import {
  universalReferenceActions,
  UniversalReferenceStore,
} from '../../../universal-reference/store/universalReferenceStore';
import { ALL_RUSSIA, ALL_RUSSIA_NAME, NO_REGION } from '../../../orders/constants/fias';

// Общий модульный дефолт: ссылка на пустой массив не меняется от рендера к рендеру
const EMPTY_ARRAY: Array<string | number> = [];

type RegionSelectorProps = Omit<ComponentProps<typeof SelectInput>, 'value' | 'defaultValue'> & {
  name?: string,
  /** id региона, которого может не быть в списке — не исключать его фильтром excludedRegions. */
  addRegionId?: string,
  /** Добавить служебную опцию «Вся Россия» (ALL_RUSSIA). */
  addAllRussia?: boolean,
  /** Скрыть служебную опцию «Без региона» (NO_REGION). */
  hideNoRegion?: boolean,
  /** Исключить регионы с этими id. */
  excludedRegions?: Array<string | number>,
  /** из inject('universalReferenceStore') */
  universalReferenceStore?: UniversalReferenceStore,
};

const RegionSelector = (props: RegionSelectorProps) => {
  const {
    universalReferenceStore, excludedRegions = EMPTY_ARRAY, addRegionId, addAllRussia, hideNoRegion, name = 'fiasId', ...rest
  } = props;
  const { subjectRF, loadingSubjectRF } = universalReferenceStore;

  // Мемоизированный список регионов — стабильная ссылка массива для data между рендерами
  const data = useMemo(() => {
    let returnData = hideNoRegion ? subjectRF.filter(v => v.id !== NO_REGION) : [...subjectRF];
    if (addAllRussia) { returnData = [...returnData, { id: ALL_RUSSIA, name: ALL_RUSSIA_NAME }]; }

    if (excludedRegions) {
      return returnData.filter(v => (!excludedRegions.includes(v.id) || (v.id === addRegionId)));
    }
    return returnData;
  }, [addRegionId, addAllRussia, excludedRegions, hideNoRegion, subjectRF]);

  useComponentDidMount(() => {
    // гейт load-once живёт в сторе: повторные mount'ы не дублируют запрос
    universalReferenceActions.getSubjectRF();
  });

  return (
    <SelectInput
      { ...rest }
      name={ name }
      data={ data }
      dataTitle='name'
      dataValue='id'
      loading={ loadingSubjectRF }
      sort
    />
  );
};

export default inject('universalReferenceStore')(observer(RegionSelector));
